import { Component } from '@angular/core';

@Component({
    selector: 'app-unsupported-operating-system',
    templateUrl: './unsupported-operating-system.component.html',
    styleUrls: ['./unsupported-operating-system.component.scss'],
    standalone: false
})
export class UnsupportedOperatingSystemComponent {}
